import moment from "moment";
import I18n from "src/I18n/I18n";
moment.locale(I18n());

export default moment;
